import React, { Component } from 'react'
import { connect } from 'react-redux'

import { withStyles } from '@material-ui/core/styles';

import Cheader from '../../containers/Cheader';
import Cfooter from '../../containers/Cfooter';

const styles = theme => ({
    root: {
        color: 'grey',
        textAlign: 'center'
    }
});

class Layout extends Component {
    render() {
        const { classes } = this.props;
        
        return (
            <div className={classes.root}>
                <header>
                    {(this.props.loginState === 2 || this.props.loginState === 4) &&
                        <Cheader />
                    }
                </header>
                <main>
                    {this.props.children}
                </main>
                <footer>
                    {(this.props.loginState === 2 || this.props.loginState === 4) &&
                        <Cfooter />
                    }
                </footer>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loginState: state.login.loginState
    }
}

export default connect(mapStateToProps)(withStyles(styles)(Layout));


// WEBPACK FOOTER //
// ./src/components/Layout/index.js